import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

import * as echarts from 'echarts'
import VueECharts from 'vue-echarts'

Vue.use(ElementUI)
Vue.component('v-chart', VueECharts)

Vue.prototype.$echarts = echarts

import '@/permission'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
